import { ActionModal } from 'br2s-ui-componentlibrary_r2_02';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SESSION_MODAL_CONTENT } from '@/utilities/constants';
import { LocalStorageService, useHTTPError } from 'br2s-ui-common-utils-02';
import { useStore } from '@/redux/store';

const TokenManager = () => {
  const { closeError } = useHTTPError();
  const { logoff } = useStore();
  const navigate = useNavigate();
  const [refreshTokenCounterExpired, setRefreshTokenCounterExpired] =
    useState(false);

  useEffect(() => {
    const checkTokenExpired = () => {
      if (!LocalStorageService.hasAuth()) {
        return;
      }
      setRefreshTokenCounterExpired(true);
      localStorage.clear();
      logoff();
      localStorage.setItem('mockAuth', 'true');
    };

    const tokenExpiredListener = () => {
      window.addEventListener(
        'refresh_token_counter_expire',
        checkTokenExpired,
      );
    };

    tokenExpiredListener();

    return () => {
      window.removeEventListener(
        'refresh_token_counter_expire',
        checkTokenExpired,
      );
    };
  }, []);

  const closeSessionModal = () => {
    setRefreshTokenCounterExpired(false);
    navigate('/ ');
    closeError();
  };

  return (
    <ActionModal
      id="session-modal"
      isOpen={refreshTokenCounterExpired}
      title={SESSION_MODAL_CONTENT.title}
      actionTitle={SESSION_MODAL_CONTENT.description}
      actionButton2={{
        id: 'back-button',
        label: SESSION_MODAL_CONTENT.buttonLabel,
        type: 'primary',
        size: 'large',
        onClick: () => closeSessionModal(),
      }}
      onCloseClick={() => closeSessionModal()}
    />
  );
};

export default TokenManager;
